import Vue from 'vue'
import Print from 'vue-print-nb'
import App from './App'
import router from './router'
import store from './store'
import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.scss'
import '@/assets/css/mixin.scss'
import '@/assets/css/assist.scss'
import VueClipboard from 'vue-clipboard2'
import $api from '@/api/index'
import date from '@/assets/js/date.js'

Vue.config.productionTip = false

Vue.use(RouterTab)
Vue.use(ElementUI)
Vue.use(Print)
Vue.use(date)
Vue.use(VueClipboard)
Vue.prototype.$ELEMENT = {size: 'medium'}
Vue.prototype.$api = $api
Vue.prototype.$baseApiUrl = process.env.NODE_ENV === 'production' ? 'https://bjgd.vip' : window.location.origin
Vue.prototype.$apiUrl = process.env.NODE_ENV === 'production' ? '/api' : '/api'

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js